export const SCROLL_SHIFT_TIME = 500;

/**
 * Will smoothly scroll the given element to the horizontal target position
 * @param element - the element to scroll
 * @param targetPosition - the target x position to scroll to in px
 * @param time - the amount of ms to spead the slide over in ms
 */
export const slideHorizontalScroll = (element: HTMLElement, targetPosition: number, time = SCROLL_SHIFT_TIME) => {
  let startTime: number | undefined;
  const startPosition = element.scrollLeft ?? 0;

  const step = (currentTime: number) => {
    if (startTime === undefined) {
      startTime = currentTime;
    }

    const increment = (targetPosition - startPosition) / time;
    const progress = currentTime - startTime;
    const newPosition = startPosition + progress * increment;

    element.scrollTo({ left: newPosition });

    if (progress < time) {
      window.requestAnimationFrame(step);
    } else {
      element.scrollTo({ left: targetPosition });
    }
  };

  window.requestAnimationFrame(step);
};
